app.controller('teacherAppExerciseMapCtrl', [
    '$scope', '$interval', 'gameService', '$state', '$stateParams', '$interval', 'locationService', function ($scope, $interval, gameService, $state, $stateParams, $interval, locationService) {
        $scope.gameService = gameService;

        $scope.exercise = gameService.exerciseWithIndex($stateParams.id);

		$scope.curPos = [0.0, 0.0];
        $scope.targetPos = $scope.exercise.mapPos;
		$scope.targetOKDistanceKM = gameService.config.targetOKDistanceKM;
        $scope.closeEnough = false;
        $scope.nonInteractive = false;

    	$scope.map = new maptalks.Map('maptalksc', {
        	center: gameService.config.mapCenter,
        	zoom: 16.64,
        	bearing: 150.0,
        	attribution: false,

	        //allow map to drag pitching, true by default
        	dragPitch : false,
        	//allow map to drag rotating, true by default
        	dragRotate : true,
        	//enable map to drag pitching and rotating at the same time, false by default
        	dragRotatePitch : false,

        	baseLayer: new maptalks.TileLayer('base', {
          		urlTemplate: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
          		subdomains: ['a','b','c','d'],
          		attribution: ''
        	})
      	});

		var center = $scope.map.getCenter();
		var layer = new maptalks.VectorLayer('vector').addTo($scope.map);

        $scope.rideMarkers = {};

        for (var i = 0; i < $scope.gameService.rides.length; i++) {
            var ride = $scope.gameService.rides[i];

            if (ride.enabled) {
                var marker = new maptalks.Marker(ride.location, {
                    'symbol' : {
                        'markerFile'   : ride.markerImage,
                        'markerWidth'  : ride.markerWidth,
                        'markerHeight' : ride.markerHeight,
                        'markerDx'     : 0,
                        'markerDy'     : 0,
                        'markerOpacity': 1
                    }
                });
                $scope.rideMarkers[ride.key] = marker;
                marker.addTo(layer);
            }
        }

        // Add the go-to pos
      	$scope.targetMarker = new maptalks.Marker(
        	$scope.targetPos,
        	{
	          	'symbol' : {
	            	'markerFile'   : window.location.origin + '/img/map/MapPin.svg',
	            	'markerWidth'  : 2*22,
	            	'markerHeight' : 2*35.5,
	            	'markerDx'     : 0,
	            	'markerDy'     : 0,
	            	'markerOpacity': 1
	          	}
	    	}
      	);
      	$scope.targetMarker.addTo(layer);

       // Add the You marker.
       $scope.youMarker = new maptalks.Marker($scope.curPos, {
          	'symbol' : {
            	'markerFile'   : window.location.origin + '/img/map/marker-you.svg',
            	'markerWidth'  : 22,
            	'markerHeight' : 22,
            	'markerDx'     : 0,
            	'markerDy'     : 0,
            	'markerOpacity': 1
          	}
        });
        $scope.youMarker.addTo(layer);

        $scope._intervalPromise = $interval(function() {
        	$scope.onLocationUpdated();
        }, 1000);

        $scope.$on('$destroy', function() {
        	$interval.cancel($scope._intervalPromise);
        })

        $scope.onLocationUpdated = function () {
        	var pos = locationService.getLocation();
        	if (!pos) {
        		return;
        	}

        	$scope.curPos = [pos.lng, pos.lat];

        	// Update closeEnough state.
        	var distanceKM = locationService.distanceInKM({lat: $scope.curPos[0], lng: $scope.curPos[1]}, {lat: $scope.targetPos[0], lng: $scope.targetPos[1]});
        	$scope.closeEnough = (distanceKM <= gameService.config.targetOKDistanceKM);

        	// Update nonInteractive state.
        	if (gameService.config.allowMapClickThrough) {
        		$scope.nonInteractive = false;
        	} else {
        		$scope.nonInteractive = !$scope.closeEnough;
        	}

        	console.log("studentExerciseMapCtrl#onLocationUpdated: distanceKM = " + distanceKM);
        	console.log("studentExerciseMapCtrl ")

        	$scope.youMarker.setCoordinates($scope.curPos);
        }

        $scope.onLocationUpdated();

        $scope.go = function() {
        	$state.go('teacherapp.exercisebegin', {id: $stateParams.id});
        }
   }
]);